import { jsx as _jsx } from "react/jsx-runtime";
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import { TranslatableString } from '@rjsf/utils';
/** The `AddButton` renders a button that represent the `Add` action on a form
 */
export default function AddButton({ uiSchema, registry, ...props }) {
    const { translateString } = registry;
    return (_jsx(IconButton, { title: translateString(TranslatableString.AddItemButton), ...props, color: 'primary', children: _jsx(AddIcon, {}) }));
}
//# sourceMappingURL=AddButton.js.map